import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import ScorecardReportModel from 'scoreboard/reports/scorecard-report/scorecard-report-model'
import globals from 'scoreboard/components/globals'
import projects from 'scoreboard/projects/projects'
import unwrapModel from 'scoreboard/components/unwrap-model'

/**
 * Data model representing a report used for selecting items to mass edit
 */
const MassEditReportModel = ScorecardReportModel.extend({

	defaultColumns: ['id', 'label','organization'],

	omitProjectFilter: true,

	defaults() {
		return {
			organizationId: this.getDefaultOrg(),
			subtype: 'scorecard-report-designer',
			type: 'report',
			label: i18n.get('report.common.new'),
			filters: {},
			structure: {
				stacks: [
					this._defaultStackData('label'),
					this._defaultStackData('id'),
					this._defaultStackData('organization')
				]
			},
			groupBy: ['organization'],
			showIndividualRecords: true,
			showIdsInMetaData: true
		}
	},

	fetchOptions: {
		showCount: true,
		showTotal: true,
		queryAllColumns: true
	},

	getDefaultOrg: function() {
		if (!_.isNil(globals.orgId)) {
			return globals.orgId
		}
		let projectId = projects.selectedOrFirstId()
		let orgId = _.get(unwrapModel(projects.get(projectId)), 'orgId')
		// if globals.orgId was not yet set, set it to be the root org for the
		// project, in order to prevent blowups when using the "Scorecard Items
		// in Multiple Organizations" filter
		orgId && (globals.orgId = orgId)
		return orgId
	},

	fetch: function(options = {}) {
		let filters = this.get('filters') || []
		//prevent the fetch unless there are filters defined and there is a field
		//selected, otherwise we could return a lot of results that aren't shown
		//on the view and the scroller's algorithm will attempt to load everything
		if (_.isEmpty(filters) || _.isNil(this.selectedField)) {
			return
		}

		return ScorecardReportModel.prototype.fetch.apply(this, arguments)
	}

})

export default MassEditReportModel
MassEditReportModel.__filename__ = 'admin/mass-edit/mass-edit-report-model.js'
